





































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";

@Component
export default class CustomForm extends Vue {
  buttonDisabled = false;

  loginInfo = {
    userId: "",
    userPw: "",
    userHp: "",
  };

  findOption = {
    minDate: moment()
      .subtract("7", "d")
      .format("YYYY-MM-DD"),
    maxDate: moment().format("YYYY-MM-DD"),
    datetime: "",
    status: "",
  };

  findResult = {
    datetime: "",
    status: "",
    requests: [],
  };

  assignOption = {
    requestId: "",
    plannerId: "",
  };

  getRequestsFromDashboard() {
    this.buttonDisabled = true;
    axios({
      url: "https://api.bople.kr",
      method: "post",
      data: {
        query: `
          query{
            getRequestsFromDashboard(
              plannerId:"${this.loginInfo.userId}",
              password:"${this.loginInfo.userPw}",
              phone:"${this.loginInfo.userHp}",
              date:"${this.findOption.datetime}",
              status:"${this.findOption.status}"
            ){
              success, data
            }
          }
        `,
      },
    })
      .then((res) => {
        if ("errors" in res.data) {
          alert("조회 실패");
        } else {
          const result = res.data.data.getRequestsFromDashboard;
          this.findResult.requests = JSON.parse(result.data);
          this.findResult.datetime = this.findOption.datetime;
          this.findResult.status = this.findOption.status;
        }
      })
      .catch((err) => {
        alert("오류가 발생했습니다. 다시 시도해주세요.");
      })
      .finally(() => {
        this.buttonDisabled = false;
      });
  }

  assignRequestFromDashboard() {
    this.buttonDisabled = true;

    axios({
      url: "https://api.bople.kr",
      method: "post",
      data: {
        query: `
        mutation{
            assignRequestFromDashboard(
                      plannerId:"${this.loginInfo.userId}",
                      password:"${this.loginInfo.userPw}",
                      phone:"${this.loginInfo.userHp}",
                      requestId:"${this.assignOption.requestId}",
                      assignedPlannerId:"${this.assignOption.plannerId}"
                ){
                success
            }
        }
        `,
      },
    })
      .then((res) => {
        if ("errors" in res.data) {
          alert("배정 실패");
        } else {
          const result = res.data.data.assignRequestFromDashboard;
          if (result.success) {
            this.getRequestsFromDashboard();
            alert("배정 성공");
          } else {
            alert("배정 실패");
          }
        }
      })
      .catch((err) => {
        alert("오류가 발생했습니다. 다시 시도해주세요.");
      })
      .finally(() => {
        this.buttonDisabled = false;
      });
  }
}
